// ===========================================================
// ERP ATTENDANCE MODULE
// ===========================================================

// Initialize Attendance System
window.initAttendanceSystem = function() {
  console.log("Initializing Attendance System...");
  
  const clockInterval = startAttendanceClock();
  fetchAttendanceHistory();
  
  return () => clearInterval(clockInterval);
};

// Clock Function
function startAttendanceClock() {
  const updateClock = () => {
    const now = new Date();
    
    const timerEl = document.getElementById('att-timer');
    if (timerEl) timerEl.innerText = now.toLocaleTimeString('en-GB', { hour12: false });

    const dayEl = document.getElementById('current-day-display');
    const dateEl = document.getElementById('current-date-display');
    
    if (dayEl) {
      dayEl.innerText = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(now);
    }
    if (dateEl) {
      dateEl.innerText = now.toLocaleDateString('en-GB');
    }
  };

  updateClock();
  return setInterval(updateClock, 1000);
}

// Mark Attendance
window.markAttendance = async () => {
  const userName = window.USER_NAME || document.querySelector('.user-name')?.innerText;
  
  if (!userName || userName === "Staff") {
    alert("Error: User name not found. Please refresh the page.");
    return;
  }

  if (!navigator.geolocation) {
    alert("Geolocation is not supported by your browser.");
    return;
  }

  if (window.toggleLoader) window.toggleLoader(true);

  navigator.geolocation.getCurrentPosition(
    async (pos) => {
      const { latitude, longitude } = pos.coords;
      
      try {
        const res = await fetch(SYSTEM.BRIDGE, {
          method: 'POST',
          mode: 'cors',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify({
            auth_key: SYSTEM.AUTH,
            endpoint: '/attendance_log',
            method: 'POST',
            data: { 
              name: userName, 
              lat: latitude, 
              lng: longitude,
              timestamp: new Date().toISOString(),
              timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
            }
          })
        });

        const result = await res.json();
        showAttendanceNotification(result.status === "success", result.message);
        
        if (result.status === "success") {
          await fetchAttendanceHistory();
        }

      } catch (e) {
        console.error("Attendance Error:", e);
        showAttendanceNotification(false, "Server connection failed. Please try again.");
      } finally {
        if (window.toggleLoader) window.toggleLoader(false);
      }
    },
    (err) => {
      if (window.toggleLoader) window.toggleLoader(false);
      let errorMsg = "Location access denied.";
      if (err.code === 1) errorMsg = "Please enable location permissions to mark attendance.";
      else if (err.code === 2) errorMsg = "Location unavailable. Please try again.";
      else if (err.code === 3) errorMsg = "Location request timed out.";
      
      alert(errorMsg);
    },
    { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
  );
};

// Fetch Attendance History
async function fetchAttendanceHistory() {
  const userName = window.USER_NAME || document.querySelector('.user-name')?.innerText || "Staff";
  const target = document.getElementById('attendance-history-list');
  const presentStat = document.getElementById('stat-attendance-present');
  const absentStat = document.getElementById('stat-attendance-absent');
  
  if (!target) return;

  target.innerHTML = "<div style='text-align:center;padding:20px;opacity:0.5;'>⏳ Loading history...</div>";

  try {
    const res = await fetch(SYSTEM.BRIDGE, {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({
        auth_key: SYSTEM.AUTH,
        endpoint: '/get_history', 
        data: { name: userName }
      })
    });

    if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);

    const responseData = await res.json();
    let history = [];
    
    if (Array.isArray(responseData)) {
      history = responseData;
    } else if (responseData && Array.isArray(responseData.data)) {
      history = responseData.data;
    } else if (responseData && Array.isArray(responseData.history)) {
      history = responseData.history;
    } else if (responseData && typeof responseData === 'object') {
      history = Object.values(responseData);
    }

    updateAttendanceStats(history, presentStat, absentStat);
    renderAttendanceHistory(history, target);

  } catch (e) {
    console.error("History Load Error:", e);
    target.innerHTML = `
      <div style="text-align:center;padding:20px;color:#ef4444;">
        <div style="font-size:24px;margin-bottom:10px;">⚠️</div>
        <div>Sync Error: ${e.message}</div>
        <button onclick="fetchAttendanceHistory()" style="margin-top:10px;padding:5px 15px;">Retry</button>
      </div>`;
  }
}

// Update Attendance Stats
function updateAttendanceStats(history, presentEl, absentEl) {
  if (!Array.isArray(history)) return;
  
  const todayStr = new Date().toLocaleDateString('en-GB');
  
  const presentToday = history.filter(item => {
    if (!item || !item.date) return false;
    return item.date === todayStr && !item.status?.includes('Absent');
  }).length;
  
  const totalStaff = 10;
  
  if (presentEl) presentEl.innerText = presentToday;
  if (absentEl) absentEl.innerText = Math.max(0, totalStaff - presentToday);
}

// Render Attendance History
function renderAttendanceHistory(history, target) {
  if (!Array.isArray(history) || history.length === 0) {
    target.innerHTML = `
      <div style="text-align:center;padding:30px;opacity:0.6;">
        <div style="font-size:40px;margin-bottom:10px;">📋</div>
        <div>No attendance records found.</div>
        <small style="display:block;margin-top:10px;">Be the first to punch in today!</small>
      </div>`;
    return;
  }

  const sortedHistory = [...history].sort((a, b) => {
    if (!a.date || !b.date) return 0;
    const [d1, m1, y1] = a.date.split('/').map(Number);
    const [d2, m2, y2] = b.date.split('/').map(Number);
    return new Date(y2, m2 - 1, d2) - new Date(y1, m1 - 1, d1);
  });

  target.innerHTML = sortedHistory.map(item => {
    const statusClass = getStatusClass(item.status);
    const icon = getStatusIcon(item.status);
    
    return `
      <div class="history-item" style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 15px;
        border-bottom: 1px solid #eee;
        background: ${item.date === new Date().toLocaleDateString('en-GB') ? '#f0fdf4' : 'transparent'};
      ">
        <div style="display:flex;align-items:center;gap:10px;">
          <span style="font-size:16px;">${icon}</span>
          <div>
            <div style="font-weight:600;">${item.date || 'Unknown Date'}</div>
            ${item.time ? `<small style="color:#666;">${item.time}</small>` : ''}
          </div>
        </div>
        <span style="
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          ${statusClass}
        ">${item.status || 'Unknown'}</span>
      </div>`;
  }).join('');
}

// Helper Functions
function getStatusClass(status) {
  if (!status) return 'background:#e5e7eb;color:#374151;';
  if (status.includes('Present')) return 'background:#dcfce7;color:#166534;';
  if (status.includes('Late')) return 'background:#fef3c7;color:#92400e;';
  if (status.includes('Absent')) return 'background:#fee2e2;color:#991b1b;';
  if (status.includes('Leave')) return 'background:#dbeafe;color:#1e40af;';
  return 'background:#e5e7eb;color:#374151;';
}

function getStatusIcon(status) {
  if (!status) return '⏱️';
  if (status.includes('Present')) return '✅';
  if (status.includes('Late')) return '🕒';
  if (status.includes('Absent')) return '❌';
  if (status.includes('Leave')) return '🏖️';
  return '⏱️';
}

// Show Notification
function showAttendanceNotification(isSuccess, message) {
  let notif = document.getElementById('attendance-notification');
  if (!notif) {
    notif = document.createElement('div');
    notif.id = 'attendance-notification';
    notif.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 15px 25px;
      border-radius: 8px;
      color: white;
      font-weight: 600;
      z-index: 10000;
      transition: all 0.3s ease;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    `;
    document.body.appendChild(notif);
  }

  notif.style.background = isSuccess ? '#10b981' : '#ef4444';
  notif.innerHTML = `${isSuccess ? '✅' : '❌'} ${message}`;
  notif.style.opacity = '1';
  notif.style.transform = 'translateY(0)';

  setTimeout(() => {
    notif.style.opacity = '0';
    notif.style.transform = 'translateY(-20px)';
  }, 4000);
}

// Export Attendance
window.exportAttendanceToExcel = async () => {
  const userName = window.USER_NAME || document.querySelector('.user-name')?.innerText || "Admin";
  
  if (window.toggleLoader) window.toggleLoader(true);

  try {
    const res = await fetch(SYSTEM.BRIDGE, {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({
        auth_key: SYSTEM.AUTH,
        endpoint: '/get_history',
        data: { name: userName, export_full: true }
      })
    });
    
    const data = await res.json();
    const exportData = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : []);
    
    if (exportData.length === 0) {
      alert("No data to export.");
      return;
    }

    let csv = "Date,Time,Status\n";
    exportData.forEach(row => {
      csv += `"${row.date || ''}","${row.time || ''}","${row.status || ''}"\n`;
    });

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Attendance_${userName}_${new Date().toLocaleDateString('en-GB').replace(/\//g, '-')}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    
  } catch (e) {
    alert("Export failed: " + e.message);
  } finally {
    if (window.toggleLoader) window.toggleLoader(false);
  }
};

// Admin Manual Update
window.adminAdjustAttendance = async () => {
  const name = document.getElementById('manual-staff-name')?.value;
  const date = document.getElementById('manual-date')?.value;
  const status = document.getElementById('manual-status')?.value;

  if (!name || !date || !status) {
    alert("Please fill all fields!");
    return;
  }

  const dayNum = parseInt(date);
  if (isNaN(dayNum) || dayNum < 1 || dayNum > 31) {
    alert("Please enter a valid date (1-31)!");
    return;
  }

  if (window.toggleLoader) window.toggleLoader(true);

  try {
    const res = await fetch(SYSTEM.BRIDGE, {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({
        auth_key: SYSTEM.AUTH,
        endpoint: '/admin_adjust',
        data: { 
          name, 
          date: `${date}/${new Date().toLocaleDateString('en-GB').split('/').slice(1).join('/')}`, 
          status 
        }
      })
    });

    const result = await res.json();
    showAttendanceNotification(result.status === "success", result.message);
    
    if (result.status === "success") {
      fetchAttendanceHistory();
    }
  } catch (e) {
    showAttendanceNotification(false, "Update failed: " + e.message);
  } finally {
    if (window.toggleLoader) window.toggleLoader(false);
  }
};